import { IApplicationState } from '../types/redux';

export const selectGeoRegion = (state: IApplicationState) => state.geoSwitcher.region?.id;
